// The backend sends naive server timestamps ("2026-10-21 14:03:11.123456");
// Safari only parses them in ISO form with at most milliseconds.
export const parseDate = (value: string): Date =>
  new Date(value.replace(" ", "T").replace(/(\.\d{3})\d+/, "$1"));

export const formatDate = (
  value: string | null | undefined,
  language: string,
) =>
  value
    ? parseDate(value).toLocaleDateString(language, {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
    : "";

export const formatDateTime = (
  value: string | null | undefined,
  language: string,
) =>
  value
    ? parseDate(value).toLocaleString(language, {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "";

export const formatVolume = (
  volume: number | null,
  currency: string,
  language: string,
) =>
  volume === null
    ? ""
    : volume.toLocaleString(language, {
        style: "currency",
        currency,
        maximumFractionDigits: 0,
      });

/** "2027-Q1" -> "Q1 2027". */
export const formatQuarter = (value: string) => {
  const [year, quarter] = value.split("-");
  return quarter ? `${quarter} ${year}` : value;
};

/** The current and the next eleven quarters, as stored ("2027-Q1"). */
export const upcomingQuarters = (from = new Date()): string[] => {
  const quarters: string[] = [];
  let year = from.getFullYear();
  let quarter = Math.floor(from.getMonth() / 3) + 1;
  for (let i = 0; i < 12; i += 1) {
    quarters.push(`${year}-Q${quarter}`);
    quarter += 1;
    if (quarter > 4) {
      quarter = 1;
      year += 1;
    }
  }
  return quarters;
};

export const displayName = (
  user: { name: string; surname: string } | null | undefined,
) => (user ? `${user.name} ${user.surname}`.trim() : "");
